import { defineAction } from "rd-action-creators";

export const someAction = defineAction<{}>("SOME ACTION");

export const changeCreateUserModalStatusAction = defineAction<{ isOpen: boolean }>(
    "CHANGE CREATE USER MODAL STATUS ACTION"
);

export const createUserAction = defineAction("CREATE USER ACTION");

export const removeUserByIdAction = defineAction<{ userId: string }>("REMOVE USER BY ID ACTION");
